module.exports = __webpack_public_path__ + "static/media/logo.b796bdfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 79
// module chunks = 0